<template>
  <div class="login-page">
    <section class="login-container">

      <!-- Franja Gobierno de Chile -->
      <div class="government-strip" aria-hidden="true">
        <span class="government-strip-blue"></span>
        <span class="government-strip-red"></span>
      </div>

      <!-- Encabezado institucional propio de la vista -->
      <header class="institution-header">
        <img
          class="institution-mark"
          :src="require('@/assets/img/logo_gobierno.png')"
          alt="Gobierno de Chile"
        />

        <span>Servicio Nacional de Prevención y Respuesta ante Desastres</span>
      </header>

      <!-- Área principal -->
      <main class="login-hero">

            <svg
            class="mountain-background"
            viewBox="0 0 700 220"
            preserveAspectRatio="none"
            aria-hidden="true"
            >
            <rect
                x="0"
                y="0"
                width="700"
                height="220"
                fill="var(--color-navy)"
            />

            <polygon
                class="mountain-layer mountain-layer-back"
                points="
                0,150
                90,70
                180,140
                260,55
                340,130
                430,60
                520,135
                610,75
                700,145
                700,220
                0,220
                "
            />

            <polygon
                class="mountain-layer mountain-layer-middle"
                points="
                0,180
                120,120
                230,170
                330,110
                460,175
                580,115
                700,170
                700,220
                0,220
                "
            />

            <polygon
                class="mountain-layer mountain-layer-front"
                points="
                0,210
                150,190
                300,215
                450,188
                600,213
                700,200
                700,220
                0,220
                "
            />
            </svg>

        <div class="login-content">

          <!-- Nombre del sistema -->
          <div class="login-brand">
            <h1>
              Visor <span>GRD</span>
            </h1>

            <p>Gestión del Riesgo de Desastres</p>
          </div>

          <!-- Formulario -->
          <div class="center-box">

            <!-- Se conserva el contenido original, pero se oculta visualmente -->
            <div class="center-aux login-original-title">
              <p class="title-text">Bienvenido</p>
            </div>

            <div class="center-input">
              <label for="username">Correo electrónico o login</label>

              <input
                id="username"
                v-model="username"
                type="text"
                v-on:keyup.enter="onClickGoNext"
                name="correo electrónico o login"
                :class="{ error: errors.has('correo electrónico o login') }"
                v-validate="'required'"
                :placeholder="[['Escriba su correo electrónico o login']]"
              />

              <p
                class="error-label"
                v-if="errors.has('correo electrónico o login')"
              >
                {{ errors.first('correo electrónico o login') }}
              </p>
            </div>

            <br />

            <div class="center-input">
              <label for="password">Contraseña</label>

              <div class="password-input-wrap">
                <input
                  id="password"
                  v-model="password"
                  :type="showPassword ? 'text' : 'password'"
                  v-on:keyup.enter="onClickGoNext"
                  name="contraseña"
                  :class="{ error: errors.has('contraseña') }"
                  v-validate="'required'"
                  :placeholder="[['Escriba su contraseña']]"
                />
                <button
                  type="button"
                  class="pw-toggle"
                  :aria-label="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                  @click="showPassword = !showPassword"
                >
                  <font-awesome-icon :icon="showPassword ? 'eye-slash' : 'eye'"></font-awesome-icon>
                </button>
              </div>

              <p
                class="error-label"
                v-if="errors.has('contraseña')"
              >
                {{ errors.first('contraseña') }}
              </p>
            </div>

            <span
              class="center-input login-message"
              v-if="message"
            >
              {{ message }}
            </span>

            <div class="center-aux login-action">
              <LoadSpinner v-if="showSpinner">
              </LoadSpinner>

              <button
                v-else
                class="btn btn-primary"
                v-on:click="onClickGoNext()"
              >
                Iniciar sesión
              </button>
            </div>

            <div class="center-aux login-recover">
              <button class="login-recover-link" @click="$router.push('/recuperar-contrasena')">
                ¿Olvidaste tu contraseña?
              </button>
            </div>
          </div>
        </div>
      </main>

      <footer class="login-bottom-bar">
        <img
          class="login-footer-logo"
          :src="require('@/assets/img/imago-citiaps-blanco.svg')"
          alt="CITIAPS - Innovación en TI para Aplicaciones Sociales"
        />
      </footer>
    </section>
  </div>
</template>

<style>
.login-recover {
  margin-top: 0.75rem;
}
.login-recover-link {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 0.83rem;
  color: #334155;
  text-decoration: underline;
}
.login-recover-link:hover {
  color: #0f172a;
}
</style>

<script>
import LoadSpinner from '@/components/LoadSpinner.vue'
import {landingRouteForPermissions} from '@/components/mixin/navigationRoutes.js'

export default{
    name: 'login',
    data(){
        return{
            username: null,
            password: null,
            showPassword: false,
            message: null,
            showSpinner: false,
        }
    },
    components:{
        LoadSpinner
    },
    computed: {

    },
    props: [],
    methods:{
        hello: function() {
            console.log('Enter')
        },
        onClickGoNext: function() {
            const that = this;
            this.$validator.validateAll()
            .then(function (response) {
                if(response) {
                    console.log('OK')
                    that.onClickLogin();
                } else {
                    console.log('NOPE')
                }
            })
        },
        onClickLogin: function(){
            const that = this;
            this.showSpinner = true;
            console.log("Store Backend URL:", this.$store.getters.backendurl);
            this.$http.post(this.$store.getters.backendurl + 'api/v1/login',
            {
                username: this.username,
                password: this.password
            })
            .then(function (response) {
                that.message = response.data.message;
                //Crear cookie — el backend codifica el header (ASCII-only) para poder llevar tildes/ñ, se decodifica acá
                document.cookie = "session_public=" + decodeURIComponent(response.headers.userpermissions);
                //document.cookie = "session_token=" + response.headers.token;
                //Guardar permisos de usuario
                that.$store.commit('setPermissions');
                //Guardar token
                //that.$store.commit('setToken');
                //Por defecto, se envía el token de sesión en cada consulta
                //that.$http.defaults.headers.common = {'Authorization': 'Bearer ' + that.$store.getters.getToken}
                //Inicio
                that.showSpinner = false;
                const returnTo = that.$route.query.returnTo;
                const campaignReturn = typeof returnTo === 'string' && /^\/terreno\/campanas\/[^/?#]+$/.test(returnTo)
                    ? returnTo
                    : null;
                //El destino sale del menú del propio usuario: mandar a todos al visor dejaba
                //en "página no encontrada" a quien no tiene ese permiso.
                const destination = campaignReturn || landingRouteForPermissions(that.$store.getters.getPermissions);
                if (destination) {
                    that.$router.push(destination)
                } else {
                    //La sesión quedó abierta —una cuenta sin ningún permiso puede
                    //ingresar, no es lo mismo que estar inactiva (QA-09)— pero no
                    //hay ninguna sección que mostrarle. Sin este aviso la pantalla
                    //se queda en "Login exitoso" y no ocurre nada más, que parece
                    //una falla del sistema en vez de una cuenta sin permisos.
                    that.message = 'Tu cuenta no tiene ninguna sección habilitada. Contacta a un administrador para que te asigne permisos.'
                }
            })
            .catch(function (error) {
                console.log(error)
                that.showSpinner = false;
                if (error.response?.data?.code === 'password_expired') {
                    that.message = 'Su contraseña ha caducado. Contacte a un administrador para restablecer el acceso.';
                } else {
                    that.message = error.response?.data?.message || 'Error de conexión';
                }
            });
        },
    },
    updated () {

    },
    created () {

    },
    mounted () {

    }
}
</script>

<style lang="scss" scoped>
.login-page,
.login-page * {
  box-sizing: border-box;
}

.login-page {
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;

  display: flex;
  align-items: stretch;
  justify-content: stretch;

  background: var(--color-mist);
  color: var(--color-graphite);
  font-family: 'Public Sans', system-ui, sans-serif;
}

.login-container {
  width: 100%;
  max-width: none;
  min-height: 100vh;

  display: flex;
  flex-direction: column;

  overflow: hidden;

  border: 0;
  border-radius: 0;

  background: var(--color-navy);
}

/* Franja Gobierno de Chile */

.government-strip {
  width: 100%;
  height: 5px;

  display: flex;
  flex: none;
}

.government-strip-blue,
.government-strip-red {
  flex: 1;
}

.government-strip-blue {
  background: var(--color-blue);
}

.government-strip-red {
  background: var(--color-red);
}

/* Encabezado institucional */

.institution-header {
  width: 100%;
  min-height: clamp(42px, 3.2vw, 48px);
  padding:
    clamp(7px, 0.8vw, 10px)
    clamp(16px, 1.8vw, 28px);

  display: flex;
  align-items: center;
  gap: clamp(9px, 0.8vw, 12px);
  flex: none;

  background: var(--color-dark);
  border-bottom: 1px solid var(--color-steel);

  color: var(--color-fog);
  font-size: clamp(11px, 0.8vw, 13px);
  font-weight: 600;
  line-height: 1.3;
}

.institution-mark {
  width: auto;
  height: clamp(25px, 2vw, 32px);

  display: block;
  flex: none;
  object-fit: contain;
}

/* Área principal */

.login-hero {
  position: relative;

  width: 100%;
  max-width: none;
  margin: 0;
  align-self: stretch;

  flex: 1 1 auto;
  min-height: 560px;

  overflow: hidden;

  display: flex;
  align-items: flex-start;
  justify-content: center;

  padding: clamp(56px, 7vh, 80px) 0 70px;

  background: var(--color-navy);
}

.mountain-background {
  position: absolute !important;

  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: 0 !important;

  display: block;

  /*
   * Al usar left y right en 0 junto con width: auto,
   * el SVG queda obligado a ocupar todo el contenedor.
   */
  width: auto !important;
  min-width: 100% !important;
  max-width: none !important;
  height: 100% !important;

  margin: 0 !important;
  padding: 0 !important;

  transform: none !important;

  overflow: hidden;
  pointer-events: none;
}

.login-content {
  position: relative;
  z-index: 1;

  width: 100%;
  margin: 0;
}
.mountain-layer {
  stroke: none;
}

.mountain-layer-back {
  fill: var(--color-steel);
  opacity: 0.27;
}

.mountain-layer-middle {
  fill: var(--color-steel);
  opacity: 0.5;
}

.mountain-layer-front {
  fill: var(--color-steel);
  opacity: 0.95;
}


/* Marca Visor GRD */

.login-brand {
  margin-bottom: 36px;

  text-align: center;
}

.login-brand h1 {
  margin: 0;

  color: var(--color-white);
  font-size: clamp(34px, 2.3vw, 42px);
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.3px;
}

.login-brand h1 span {
  color: var(--color-orange);
}

.login-brand p {
  margin: 8px 0 0;

  color: var(--color-fog);
  font-size: clamp(14px, 1vw, 16px);
  font-weight: 500;
  letter-spacing: 0.2px;
}

/* Tarjeta del formulario */

.center-box {
  width: calc(100% - 32px);
  max-width: 400px;
  margin: 0 auto;
  padding: 32px 36px 34px;

  border: 0;
  border-radius: 8px;

  background: var(--color-white);

  box-shadow:
    0 8px 24px
    color-mix(
      in srgb,
      var(--color-navy) 25%,
      transparent
    );
}

/* Título Bienvenido */

.login-original-title {
  display: flex;
  margin: 0 0 24px;
}

.title-text {
  margin: 0;

  color: var(--color-graphite);
  font-size: 21px;
  font-weight: 500;
  line-height: 1.2;
}

/* Elimina el salto visual original */

.center-box > br {
  display: none;
}

/* Campos */

.center-input {
  display: block;
  margin: 0 0 18px;
}

.center-input label {
  display: block;
  margin-bottom: 8px;

  color: var(--color-navy);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.3;
}

.center-input input {
  width: 100%;
  min-height: 46px;
  padding: 11px 14px;

  border: 1px solid var(--color-line);
  border-radius: 4px;

  background: var(--color-white);
  color: var(--color-graphite);

  font-family: inherit;
  font-size: 16px;

  transition:
    border-color 0.2s ease,
    outline-color 0.2s ease;
}

.password-input-wrap {
  position: relative;
}

.password-input-wrap input {
  padding-right: 40px;
}

/* Edge dibuja su propio ojo nativo y quedarian dos superpuestos */
.password-input-wrap input::-ms-reveal,
.password-input-wrap input::-ms-clear {
  display: none;
}

.pw-toggle {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);

  display: flex;
  align-items: center;
  padding: 4px;

  background: transparent;
  border: none;
  color: var(--color-ghost);
  cursor: pointer;
}

.pw-toggle:hover {
  color: var(--color-navy);
}

.center-input input::placeholder {
  color: var(--color-ghost);
}

.center-input input:hover {
  border-color: var(--color-steel);
}

.center-input input:focus {
  border-color: var(--color-steel);

  outline: 2px solid
    color-mix(
      in srgb,
      var(--color-steel) 24%,
      transparent
    );

  outline-offset: 1px;
}

.center-input input.error {
  border-color: var(--color-danger);
}

.center-input input.error:focus {
  outline-color:
    color-mix(
      in srgb,
      var(--color-danger) 20%,
      transparent
    );
}

/* Errores de validación */

.error-label {
  /* El .error-label global es position:absolute y se encima con lo que sigue (#126) */
  position: static;
  margin: 6px 0 0;

  color: var(--color-danger);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
}

/* Mensaje del servidor */

.login-message {
  margin-top: 0;
  margin-bottom: 16px;

  color: var(--color-danger);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
}

/* Contenedores auxiliares */

.center-aux {
  display: flex;
  justify-content: center;
}

/* Botón y spinner */

.login-action {
  min-height: 46px;
  margin-top: 8px;
  margin-bottom: 0;

  align-items: center;
}

.center-box .btn-primary {
  width: 100%;
  min-height: 46px;
  margin: 0;
  padding: 11px 18px;

  border: 1px solid var(--color-orange);
  border-radius: 4px;

  background: var(--color-orange);
  color: var(--color-white);

  font-family: inherit;
  font-size: 15px;
  font-weight: 700;

  cursor: pointer;

  transition:
    filter 0.2s ease,
    transform 0.1s ease;
}

.center-box .btn-primary:hover {
  filter: brightness(0.94);
}

.center-box .btn-primary:active {
  transform: translateY(1px);
}

.center-box .btn-primary:focus-visible {
  outline: 2px solid var(--color-white);
  outline-offset: 2px;
}

/* Franja inferior institucional */

/* Franja inferior institucional */

.login-bottom-bar {
  width: 100%;
  min-height: clamp(58px, 5vw, 70px);
  padding:
    8px
    clamp(16px, 2vw, 30px);

  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;

  background: var(--color-dark);
  border-top: 1px solid var(--color-steel);
}

.login-footer-logo {
  display: block;

  width: clamp(125px, 10vw, 165px);
  height: auto;
  max-height: 52px;

  object-fit: contain;
}
/* Pantallas medianas */

@media (max-width: 1024px) {
  .login-hero {
    min-height: 540px;
    padding: 50px 0 64px;
  }

  .login-brand {
    margin-bottom: 30px;
  }

  .login-brand h1 {
    font-size: 36px;
  }

  .login-brand p {
    font-size: 14px;
  }

  .center-box {
    max-width: 360px;
    padding: 28px 30px 30px;
  }

  .title-text {
    font-size: 20px;
  }

  .center-input input {
    min-height: 44px;
    font-size: 15px;
  }

  .login-action {
    min-height: 44px;
  }

  .center-box .btn-primary {
    min-height: 44px;
  }
}

/* Tablets */

@media (max-width: 768px) {
  .institution-header {
    min-height: 42px;
    padding: 7px 14px;

    gap: 9px;
    font-size: 11px;
  }

  .institution-mark {
    width: auto;
    height: 25px;
  }

  .login-hero {
    min-height: 520px;
    padding: 42px 0 60px;
  }

  .login-brand {
    margin-bottom: 28px;
  }

  .center-box {
    width: calc(100% - 32px);
    max-width: 360px;
  }

  .mountain-background {
    inset: 0;

    width: 100% !important;
    min-width: 100% !important;
    max-width: none !important;
  }

  .login-bottom-bar {
    min-height: 58px;
    padding: 8px 16px;
  }

  .login-footer-logo {
    width: 135px;
    max-height: 46px;
  }
}

/* Celulares */

@media (max-width: 480px) {
  .login-page,
  .login-container {
    width: 100%;
    min-height: 100vh;
  }

  .institution-header {
    min-height: 40px;
    padding: 7px 12px;

    gap: 8px;
    font-size: 10px;
  }

  .institution-mark {
    width: auto;
    height: 23px;
  }

  .institution-header span {
    overflow: hidden;

    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .login-hero {
    min-height: 540px;
    padding: 36px 0 54px;
  }

  .login-brand {
    margin-bottom: 26px;
  }

  .login-brand h1 {
    font-size: 30px;
  }

  .login-brand p {
    font-size: 13px;
  }

  .center-box {
    width: calc(100% - 32px);
    max-width: 340px;
    padding: 24px 20px 26px;

    border-radius: 6px;
  }

  .login-original-title {
    margin-bottom: 20px;
  }

  .title-text {
    font-size: 19px;
  }

  .center-input {
    margin-bottom: 16px;
  }

  .center-input label {
    margin-bottom: 7px;

    font-size: 12px;
  }

  .center-input input {
    min-height: 44px;
    padding: 10px 12px;

    font-size: 16px;
  }

  .login-action {
    min-height: 44px;
    margin-top: 6px;
  }

  .center-box .btn-primary {
    min-height: 44px;
    padding: 10px 16px;

    font-size: 14px;
  }

  .mountain-background {
    inset: 0;

    width: 100% !important;
    min-width: 100% !important;
    max-width: none !important;
  }

  .login-bottom-bar {
    min-height: 56px;
    padding: 8px 12px;

    display: flex;
    justify-content: center;
  }

  .login-footer-logo {
    width: 125px;
    max-height: 44px;
  }
}
</style>
